var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('DetailWeblog',{staticClass:"pt-20 px-10 pb-10 mb-40",attrs:{"coin":_vm.coin}}),_vm._v(" "),_c('Tags',{attrs:{"data":_vm.coin.data,"tether-data":_vm.coin.tetherData ? _vm.coin.tetherData : null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }